import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { StCRGridContainerWithoutBackground } from '../shared/Container/Container.styles';

export const SLMainBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

export const StItemListingGrid = styled(StCRGridContainerWithoutBackground)(({ theme }) => ({
  marginBlock: '2rem',
  [theme.breakpoints.down('lg')]: {
    margin: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '1.9rem 1.75rem',
  },
}));

export const StListingTitle = styled(Typography)(({ theme }) => ({
  color: '#002B45',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '40px',
  lineHeight: '45px',
  [theme.breakpoints.down('lg')]: {
    fontSize: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '32px',
  },
}));

export const StPaginationFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  margin: `${theme.spacing(6)} 0`,
  width: '100%',
}));

export const StPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPagination-ul': {
    gap: theme.spacing(1),
  },
  '& .MuiPaginationItem-root': {
    margin: 0,
    minWidth: 40,
    height: 40,
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutral5?.main || '#B5B5B5'}`,
    color: theme.palette.neutral7?.main || '#595959',
    fontWeight: 500,
    backgroundColor: 'transparent',
  },
  '& .MuiPaginationItem-ellipsis': {
    border: 'none',
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.white?.main || '#FFFFFF',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  '& .MuiPaginationItem-previousNext': {
    color: theme.palette.primary.main,
  },
  '& .MuiPaginationItem-previousNext.Mui-disabled': {
    color: theme.palette.neutral5?.main || '#B5B5B5',
    borderColor: theme.palette.neutral5?.main || '#B5B5B5',
    opacity: 1,
  },
}));

export const StShowingOfText = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral7?.main || '#595959',
  fontSize: '14px',
  lineHeight: 1.4,
  textAlign: 'center',
}));
